<template>
  <div class="popup-list">
    <gat-popup
      :class="[
        'popup-upload-tip',
        popupActive === 'uploadtip' ? 'on' : 'off',
      ]"
      :title="`${modelTypeCompany(modelType)}上传说明`"
      @cancel="cancelPopup"
    >
      <template v-slot:content>
        <!-- 上传提示 -->
        <ul class="tips">
          <li class="tip-list" v-if="uploadTipsType == 3">
            <i class="required">*</i>目标校验{{modelTypeCompany(modelType)}}将默认作为校验学生所训练模型的{{modelTypeCompany(modelType)}}，学生可查看预览{{modelTypeCompany(modelType)}}信息；
          </li>

          <li class="tip-list" v-if="modelType == 1 || modelType == 2">
            <i class="required">*</i>支持图片格式为：jpg/jpeg，大小限制在<b> 4MB </b>以内；
          </li>
          <li class="tip-list" v-if="modelType==3 || modelType==4">
            <i class="required">*</i>支持TXT格式文本，大小限制在<b> 500KB </b>以内；
          </li>
          <li class="tip-list" v-if="modelType==5 || modelType==6">
            <i class="required">*</i>支持WAV、MP3格式音频，大小限制在<b> 5MB </b>以内；
          </li>

          <li class="tip-list" v-if="modelType == 1 || modelType == 2">
            <i class="required">*</i>图片最大为<b> 2048px*2048px </b>，最小为<b> 64px*64px </b>；
          </li>
          <li class="tip-list" v-if="uploadTipsType == 1">
            <i class="required">*</i>单次上传{{modelTypeCompany(modelType)}}限制<b> 200个 </b>；
          </li>
          <li class="tip-list" v-if="modelType == 1 || modelType == 2">
            <i class="required">*</i>建议上传图片宽度比<b> 5:3 </b>；
          </li>

          <li class="tip-list" v-if="(modelType == 1 || modelType == 3 || modelType == 5) && uploadTipsType == 1">
            <i class="required">*</i>单个分类标签的{{modelTypeCompany(modelType)}}总数不超过<b> 200个 </b>；
          </li>
          <li class="tip-list" v-if="(modelType == 2 || modelType == 4 || modelType == 6) && uploadTipsType == 1">
            <i class="required" >*</i>单个数据集的{{modelTypeCompany(modelType)}}总数不超过<b> 3000个 </b>；
          </li>
          <li class="tip-list" v-if="uploadTipsType == 2">
            <i class="required">*</i>校验{{modelTypeCompany(modelType)}}上传最多不超过<b> 10 {{modelType==1||modelType==2?'张':'个'}} </b>；
          </li>
          <li class="tip-list" v-if="uploadTipsType == 3">
            <i class="required" >*</i>目标校验{{modelTypeCompany(modelType)}}总数不超过<b> 10个 </b>；
          </li>
        </ul>
        <!-- TODO:警告不完备 -->
        <span class="contact">若上传失败，请检查网络设置</span>
        <el-checkbox
          class="check-box"
          v-model="uploadNoTip"
          @change="uploadNoTipChange"
          >下次不再提示</el-checkbox
        >
      </template>
      <template v-slot:buttons>
        <el-button class="primary" @click="confirmUploadTip"
          >我知道了</el-button
        >
      </template>
    </gat-popup>
  </div>
</template>

<script>
import GatPopup from '@/components/common/GatPopup'

export default {
  name: 'ModelTrainingUploadTips',
  components: { GatPopup },
  props: {
    modelType: {
      type: String,
      default: '1',
    },
    popupActive: {
      type: String,
      default: '',
    },
    // targetFileShow: {
    //   type: Boolean,
    //   default: false,
    // },
    // 提示类型：1 数据集上传提示，2 模型校验上传提示，3 目标校验上传提示
    uploadTipsType: {
      type: String,
      default: '1'
    }
  },
  watch: {
    uploadTipsType() {
      this.uploadNoTip = false
    }
  },
  data() {
    return {
      uploadNoTip: false
    }
  },
  created() {
    // console.log(this.modelType)
  },
  methods: {
    // 模型类别单位过滤
    modelTypeCompany(type) {
      if (type == 1 || type == 2) {
        return '图片';
      } else if (type == 3 || type == 4) {
        return '文本';
      } else if (type == 5 || type == 6) {
        return '音频';
      }
    },
    uploadNoTipChange(val) {
      this.$emit('uploadNoTipChange', val)
    },
    confirmUploadTip() {
      this.$emit('confirmUploadTip')
    },
    cancelPopup() {
      this.$emit('cancelPopup')
    },
  },
}
</script>

<style lang="scss" scoped>
@import './pretrain_common.scss';
</style>
